import { Component, Vue } from 'nuxt-property-decorator'
import { mapState, mapGetters } from 'vuex'
import { Project } from '~/models'

@Component({
  computed: {
    ...mapState('consumer-map', {
      currentProject: 'currentProject',
    }),
    ...mapGetters('rental-map', {
      currentRentalProject: 'currentRentalProject',
    }),
  },
})
export default class DefaultImage extends Vue {
  projectSpecificPlaceholderImage: string = null
  currentProject!: Project
  currentRentalProject: Project
  sourceImage: string = ''

  created() {
    if (this.currentProject) {
      this.projectSpecificPlaceholderImage =
        this.currentProject?.home_placeholder
    } else if (this.currentRentalProject) {
      this.projectSpecificPlaceholderImage =
        this.currentRentalProject?.home_placeholder
    }

    const placeholder =
      this.projectSpecificPlaceholderImage || this.hardCodedImage()
    this.checkAndSetImage(placeholder)
  }

  async checkImageExists(url: string): Promise<boolean> {
    try {
      const response = await fetch(url, { method: 'HEAD' })
      return response.ok
    } catch (error) {
      return false
    }
  }

  async checkAndSetImage(url: string) {
    const exists = await this.checkImageExists(url)
    this.sourceImage = exists ? url : this.hardCodedImage()
  }

  defaultImage(): string {
    return this.sourceImage || this.hardCodedImage()
  }

  hardCodedImage(): string {
    return 'https://thexo-cdn.nyc3.digitaloceanspaces.com/xo-placeholder.png'
  }

  onLoad(event: any): void {
    event.target.style.backgroundImage = ''
  }

  onError(event: any): void {
    this.checkAndSetImage(this.hardCodedImage())
  }
}
